<template>
	<svg xmlns="http://www.w3.org/2000/svg" version="1.1" :width="width" :height="height">
		<defs>
			<marker id="arrow" markerWidth="13" markerHeight="13" refX="2" refY="6" orient="auto">
				<path d="M2,2 L2,11 L10,6 L2,2" :fill="color" />
			</marker>
		</defs>
		<polyline v-for="(item, i) in lines" :key="`l${i}`" fill="none" :stroke="color" stroke-width="1" :points="item"></polyline>
		<polyline v-for="(item, i) in compArrow" :key="`a${i}`" fill="none" :stroke="color" :stroke-dasharray="item.dashed ? '5,3' : ''" stroke-width="1" marker-end="url(#arrow)" :points="item.points"></polyline>
	</svg>
</template>

<script>
	export default {
		props: {
			width: String,
			height: String,
			lines: Array,
			arrow: Array,
			color: {
				type: String,
				default: '#666'
			}
		},
		
		computed: {
			compArrow() {
				return this.arrow && this.arrow.map(item => {
					return {
						dashed: item.includes('dashed'),
						points: item.replace('dashed ', '')
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>